import { PrismicRichText } from '@prismicio/react';
import { Button } from '@remote-com/norma/core/button';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';
import { Title } from '@/src/views/Services/GlobalPayroll/slices/GetYourGuideSlice';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '60px', '120px')};
  background-color: var(--colors-royalPurple);
  position: relative;

  ${({ $imageOverlay }) => {
    switch ($imageOverlay) {
      case false: {
        return css`
          overflow: hidden;
        `;
      }
      case true:
      default:
        return css``;
    }
  }}

  ${Title} {
    margin-bottom: 23px;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.bodyLead};
  max-width: 500px;
  color: var(--colors-spindle);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

const CTAButton = styled(Button)`
  && {
    margin-top: 23px;
    background-color: var(--colors-irisBlue);
  }
`;

export const IllustrationWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: -14%;
  max-width: 35%;

  ${tabletBreakpoint(css`
    display: none;
  `)};
`;

export function CtaWithIllustrationSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, ctaLabel, ctaLink, illustration, imageOverlay } = primary;

  return (
    <Section $imageOverlay={imageOverlay}>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(description) && (
          <Description>
            <PrismicRichText field={description} />
          </Description>
        )}
        {fieldHasContent(ctaLabel) && (
          <CTAButton href={ctaLink?.url} target={ctaLink?.target}>
            {ctaLabel}
          </CTAButton>
        )}
        {illustration && (
          <IllustrationWrapper>
            <Image
              src={illustration?.url}
              alt={illustration?.alt || ''}
              width={illustration?.dimensions.width}
              height={illustration?.dimensions.height}
              quality="100"
            />
          </IllustrationWrapper>
        )}
      </ContentContainer>
    </Section>
  );
}
